// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__uREOi","cell":"ColumnAccessor_cell__kiHYR","firstCellAccent":"ColumnAccessor_firstCellAccent__2Ecn3"};